import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { SavePopupResponseInput } from '@/models/caller';

export const saveGroceryPopupResponse = async ({ phoneNumber, clientResponse, notInterestedReason }: SavePopupResponseInput) => {
  const response = await mutationExecute({
    variables: {
      phoneNumber,
      clientResponse,
      notInterestedReason,
    },
    mutation: graphql(`
      mutation SaveGroceryPopupResponse($phoneNumber: String!, $clientResponse: String!, $notInterestedReason: String) {
        saveGroceryPopupResponse(phoneNumber: $phoneNumber, clientResponse: $clientResponse, notInterestedReason: $notInterestedReason) {
          id
          groceryPopup {
            callSid
            clientResponse
            notInterestedReason
          }
        }
      }
    `),
  });

  return response.data?.saveGroceryPopupResponse;
};
